import { addMonths, endOfMonth, startOfMonth } from 'date-fns'

import BaseMonthPicker from 'modules/core/components/MonthPicker'
import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { dateToString, stringToDate } from 'modules/core/lib/dates'

type Props = {
  date: Date
  onDateRangeChange: (startDate: Date, endDate: Date) => void
}

export const QuarterPicker = ({ date, onDateRangeChange }: Props) => {
  // "ui" format because MonthPicker requires it that way
  const stringDate = useUnsafeMemo(() => dateToString(date, 'ui'), [date])

  const handleOnDateRangeChange = useUnsafeCallback(
    (newDate: string) => {
      const parsedDate = stringToDate(newDate, 'ui').toDate()

      onDateRangeChange(startOfMonth(parsedDate), endOfMonth(addMonths(parsedDate, 2)))
    },
    [onDateRangeChange]
  )

  return (
    <BaseMonthPicker
      quarterPicker
      showOnlyPicker
      value={stringDate}
      onChange={handleOnDateRangeChange}
    />
  )
}
